// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-row {\n    box-sizing: border-box;\n    min-height: 64px;\n    transition: all 200ms;\n    width: 100%;\n}\n\n.message-row button, .message-row a {\n    align-items: inherit;\n    background: none;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n    display: flex;\n    height: 100%;\n    line-height: inherit;\n    margin: 0;\n    padding: 0;\n    text-align: inherit;\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
